/**
 * Pre-9am locked state. Shown when the user has already played the active
 * puzzle and is waiting for the next 9am Melbourne cutover.
 */

import { startCountdown } from '@/game/countdown';

export function renderLockedState(): HTMLElement {
  const root = document.createElement('section');
  root.className = 'locked-state';
  root.innerHTML = `
    <h2>You've played today's puzzle.</h2>
    <p>Today's is locked. Yesterday's is gone.</p>
    <p>The next puzzle drops at 9am Melbourne.</p>
    <p class="countdown-large" id="locked-countdown" aria-live="polite"></p>
  `;
  // Hydrate countdown after mount.
  setTimeout(() => {
    const cd = root.querySelector('#locked-countdown') as HTMLElement | null;
    if (cd) startCountdown(cd, '');
  }, 0);
  return root;
}
